export default "__VITE_ASSET__BXRu_NKT__"